<template>
  <div class="not-found">
    <h2>404</h2>
    <p>页面不存在,或者你还没被授予访问它的权限。</p>
    <el-button type="primary" @click="goHome">返回首页</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.not-found { padding: 80px; text-align: center; }
</style>
